var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneNumberSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8275 16.5615C14.0339 16.6563 14.2665 16.678 14.4869 16.6229C14.7073 16.5678 14.9024 16.4394 15.04 16.2586L15.3949 15.7938C15.5811 15.5455 15.8226 15.3439 16.1002 15.2051C16.3778 15.0663 16.6839 14.9941 16.9943 14.9941H19.9932C20.5234 14.9941 21.0319 15.2047 21.4068 15.5796C21.7818 15.9546 21.9924 16.4631 21.9924 16.9933V19.9922C21.9924 20.5224 21.7818 21.0309 21.4068 21.4058C21.0319 21.7808 20.5234 21.9914 19.9932 21.9914C15.2211 21.9914 10.6444 20.0957 7.27007 16.7213C3.8957 13.347 2 8.77034 2 3.99826C2 3.46803 2.21063 2.95952 2.58556 2.58459C2.96049 2.20966 3.46901 1.99902 3.99924 1.99902H6.9981C7.52833 1.99902 8.03684 2.20966 8.41177 2.58459C8.7867 2.95952 8.99734 3.46803 8.99734 3.99826V6.99712C8.99734 7.30749 8.92507 7.6136 8.78627 7.89121C8.64747 8.16881 8.44594 8.41029 8.19764 8.59651L7.72982 8.94738C7.54631 9.0875 7.41696 9.28683 7.36375 9.51151C7.31054 9.73619 7.33675 9.97236 7.43793 10.1799C8.80409 12.9547 11.051 15.1988 13.8275 16.5615Z",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneNumberSmall);
export default __webpack_public_path__ + "static/media/icon_phone_number_small.cc9f28f2ab6dc52133e2152360a96912.svg";
export { ForwardRef as ReactComponent };